import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, input, viewChild } from '@angular/core';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NavMenuItem } from '../../../../models/NavMenuItem.model';
import { IconComponent } from '@ui';

@Component({
  selector: 'app-nav-menu-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzDropDownModule,
    NzIconModule,
    NgStyle,
    IconComponent,
    NgClass
    ],
  templateUrl: 'nav-menu-header.component.html',
})
export class NavMenuHeaderComponent {
  public readonly isOpen = input.required<boolean>();
  public readonly apps = input.required<NavMenuItem[]>();
  public readonly env = input.required<string>();

  protected readonly header = viewChild<ElementRef<HTMLDivElement>>('header');

  protected readonly top = computed<number | undefined>(() => {
    const nativeElement = this.header()?.nativeElement;

    if (!nativeElement) {
      return undefined;
    }

    return nativeElement.offsetTop;
  });

  protected readonly left = computed<number | undefined>(() => {
    const nativeElement = this.header()?.nativeElement;

    if (!nativeElement) {
      return undefined;
    }

    return nativeElement.offsetLeft + nativeElement.offsetWidth;
  });

  protected open(app: NavMenuItem): void {
    window.open(app.path, '_blank');
  }
}
